require.register("app/product/price/new/PendingTab", function(exports, require, module){
  $0
  
});

